module.exports = ".addButton {\n  color: #4CAF50; }\n"